module.exports = __webpack_public_path__ + "static/media/howl.ace8fd3a.jpg";